import { useParams } from 'react-router-dom';
import { Article, library } from '@playcastdotio/ArticleContent';

export const NewsItem = () => {
  const { slug } = useParams();
  const article = library.articles[slug || 'not-found'];

  return <Article article={article} />;
};
